import moment from "moment";
import numeral from "numeral";
import ReactTable from "react-table";

export default function RatesTable(props) {
  const { data, loading, onClickEdit, onClickDelete, user, currentPage, totalPages, onPageChange } = props;
  const columns = [
    {
      Header: "#",
      Cell: ({ row, original }) => row._index + 1,
      maxWidth: 75,
      className: "text-center",
      headerStyle: { overflow: "hidden" },
      headerClassName: "text-center",
    },
    {
      Header: "ASAL",
      accessor: "origin_adm_div_lvl_2_id",
      minWidth: 150,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => locationCell(original, "origin"),
    },
    {
      Header: "TUJUAN",
      accessor: "destination_adm_div_lvl_2_id",
      minWidth: 150,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => locationCell(original, "destination"),
    },
    {
      Header: "HARGA DASAR",
      accessor: "price",
      minWidth: 100,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => amountCell(row.price),
    },
    {
      Header: "HARGA TAMBAHAN / KG",
      minWidth: 120,
      accessor: "price_per_kg",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => amountCell(row.price_per_kg),
    },
    {
      Header: "HARGA TAMBAHAN / CM 3",
      minWidth: 130,
      accessor: "price_per_vol",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => amountCell(row.price_per_vol),
    },
    {
      Header: "STATUS",
      minWidth: 60,
      accessor: "status",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => statusCell(row),
    },
    {
      Header: "WAKTU DIBUAT",
      accessor: "created_at",
      headerStyle: { whiteSpace: "unset" },
      maxWidth: 150,
      style: { whiteSpace: "unset" },
      Cell: ({ row, original }) => moment(row.created_at).format("YYYY-MM-DD HH:mm"),
    },
    {
      Header: "AKSI",
      accessor: "action",
      maxWidth: 100,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => actionCell(row._index),
    },
  ];

  if (props.user.courier && props.user.courier.courierType === "instant")
    columns.splice(6, 0, {
      Header: "HARGA TAMBAHAN / KM",
      minWidth: 120,
      accessor: "price_per_km",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => amountCell(row.price_per_km),
    });

  const actionCell = (idx) => {
    return (
      <div>
        <a
          onClick={() => props.onClickEdit(idx)}
          className="hover:underline cursor-pointer text-warning"
        >
          Edit
        </a>
        <a
          onClick={() => props.onClickDelete(idx)}
          className="hover:underline cursor-pointer ml-2 text-danger"
        >
          Delete
        </a>
      </div>
    );
  };

  const locationCell = (og, type) => {
    return (
      <div>
        <div>
          NEGARA: {og[type + "_country_id"]} - {og[type + "_country_name"]}
        </div>
        <div>
          PROVINSI: {og[type + "_adm_div_lvl_1_id"]} - {og[type + "_adm_div_lvl_1_name"]}
        </div>
        <div>
          KOTA: {og[type + "_adm_div_lvl_2_id"]} - {og[type + "_adm_div_lvl_2_name"]}
        </div>
        <div>
          KECAMATAN:{" "}
          {og[type + "_adm_div_lvl_3_id"]
            ? `${og[type + "_adm_div_lvl_3_id"]} - ${og[type + "_adm_div_lvl_3_name"]}`
            : "-"}
        </div>
        {<div>KODEPOS: {og[type + "_postal_code"] ? og[type + "_postal_code"] : "-"}</div>}
      </div>
    );
  };

  const amountCell = (og) => <div>Rp. {numeral(Math.abs(og)).format("0,0")}</div>;

  const statusCell = (row) => {
    let status;

    if (row.status === "active") {
      status = (
        <div className="text-success">
          <b>aktif</b>
        </div>
      );
    } else {
      status = <div className="text-muted">{row.status}</div>;
    }

    return <div>{status}</div>;
  };

  return (
    <div>
      <ReactTable
        data={props.data}
        columns={columns}
        loading={props.loading}
        className="-striped -highlight"
        showPagination={false} // Exclude pagination
        pageSize={5} // Show 5 items per page
      />
      <div className="pagination text-center">
        <button style={{ margin: '0 10px' }} onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
          Previous
        </button>
        <span>Page {currentPage} of {totalPages}</span>
        <button style={{ margin: '0 10px' }} onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>
    </div>
  );
}
